import React from "react";
import { employees } from "../data/employees";
import "../styles/EmployeeSelector.css";

const EmployeeSelector = ({ selectedEmployee, setSelectedEmployee }) => {
  const handleChange = (event) => {
    const selectedName = event.target.value;
    const selected = employees.find(
      (employee) => employee.name === selectedName
    );
    console.log("Selected:", selected);
    setSelectedEmployee(selected);
  };

  return (
    <div className="employee-selector-container">
      <label htmlFor="employeeSelector" className="employee-selector-label">
        社員:
      </label>
      <select
        id="employeeSelector"
        key={selectedEmployee ? selectedEmployee.name : ""}
        value={selectedEmployee ? selectedEmployee.name : ""}
        onChange={handleChange}
        className="employee-selector-select"
      >
        <option value="" disabled hidden>
          社員を選択
        </option>
        {employees.map((employee, index) => (
          <option key={index} value={employee.name}>
            {employee.name}
          </option>
        ))}
      </select>
    </div>
  );
};

export default EmployeeSelector;
